import { BasicEnumerable } from "../BasicEnumerable.js";
export const takeWhile = (source, predicate) => {
    if (predicate.length === 1) {
        return takeWhile1(source, predicate);
    }
    else {
        return takeWhile2(source, predicate);
    }
};
const takeWhile1 = (source, predicate) => {
    function* iterator() {
        for (const item of source) {
            if (predicate(item)) {
                yield item;
            }
            else {
                break;
            }
        }
    }
    return new BasicEnumerable(iterator);
};
const takeWhile2 = (source, predicate) => {
    function* iterator() {
        let index = 0;
        for (const item of source) {
            if (predicate(item, index++)) {
                yield item;
            }
            else {
                break;
            }
        }
    }
    return new BasicEnumerable(iterator);
};
